export const reload = function() {
    window.location.reload();
};
